import { disablePlaceholder } from 'shared/actions/placeholderDisabled';
import { setSearchBlockView } from 'shared/actions/searchBlockView';
import { selectSearchBlockView } from 'shared/selectors';
import { TReduxStore } from 'shared/types/redux';
import { ESearchBlockView, isSearchBlockView } from 'shared/types/searchBlockView';

/**
 * Переключает вид поискового блока: полноценная строка или компактная кнопка.
 *
 * Значение приходит снаружи, поэтому проверяем его: на неизвестный вид отвечаем ошибкой,
 * а не роняем приложение и не подставляем молча дефолт.
 */
export function handleSetView(store: TReduxStore, data: { view: ESearchBlockView }) {
  if (!isSearchBlockView(data.view)) {
    return {
      success: false,
      error: `Unknown view "${data.view}". Expected one of: ${Object.values(ESearchBlockView).join(', ')}`,
    };
  }

  const currentView = selectSearchBlockView(store.getState());

  // Уход со строки на кнопку гасит печатную машинку навсегда: при возврате строка уже
  // показывалась, и повторно проигрывать набор незачем.
  if (data.view === ESearchBlockView.Button && currentView === ESearchBlockView.SearchString) {
    store.dispatch(disablePlaceholder());
  }

  store.dispatch(setSearchBlockView(data.view));

  return {
    success: true,
    view: selectSearchBlockView(store.getState()),
  };
}
